import { Check, ExternalLink, Wallet } from "lucide-react";
import { Link } from "react-router-dom";

import { useDepositPaymentDialog } from "@/features/deposits";
import { ROUTES } from "@/shared/model/routes";
import { Button } from "@/shared/ui/kit/button";
import { ResponsiveModal } from "@/shared/ui/responsive-modal";

import { DepositCountdown } from "../ui/deposit-countdown";

export function DepositPaymentDialogCompose() {
  const {
    isOpen,
    deposit,
    setIsOpen: onOpenChange,
  } = useDepositPaymentDialog();

  const handleClose = () => {
    onOpenChange(false);
  };

  const handleOpenPayment = () => {
    if (deposit?.heleket_url) {
      window.open(deposit.heleket_url, "_blank");
    }
  };

  if (!deposit) {
    return null;
  }

  const exactAmount = (deposit.requested_amount_cents / 100).toString();

  return (
    <ResponsiveModal open={isOpen} onOpenChange={handleClose}>
      <ResponsiveModal.Content className="max-w-sm">
        <ResponsiveModal.Header>
          <div className="flex items-start gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary/10">
              <Wallet className="h-4 w-4 text-primary" />
            </div>
            <div className="flex flex-col gap-1">
              <ResponsiveModal.Title>Пополнение баланса</ResponsiveModal.Title>
              <ResponsiveModal.Description>
                Deposit funds to your account
              </ResponsiveModal.Description>
            </div>
          </div>
        </ResponsiveModal.Header>

        <ResponsiveModal.Body>
          <div className="space-y-5">
            {/* Success info */}
            <div className="flex items-center gap-3 p-4 rounded-xl bg-emerald-500/10 border border-emerald-500/20">
              <Check className="size-5 text-emerald-500 shrink-0" />
              <div>
                <p className="text-sm font-medium text-foreground">
                  Заявка создана — {exactAmount} USD
                </p>
                <p className="text-xs text-muted-foreground mt-0.5">
                  Нажмите кнопку ниже для оплаты
                </p>
              </div>
            </div>

            {/* Payment button */}
            <div className="flex flex-col items-center gap-4">
              <Button
                onClick={handleOpenPayment}
                size="lg"
                className="w-full h-12 text-base"
              >
                <ExternalLink className="size-4 mr-2" />
                Перейти к оплате
              </Button>
              <p className="text-xs text-muted-foreground text-center">
                Откроется страница платежного шлюза Heleket
              </p>
            </div>

            {/* Expires warning */}
            {deposit.expires_at && (
              <div className="rounded-lg bg-amber-500/10 border border-amber-500/20 p-3">
                <DepositCountdown expiresAt={deposit.expires_at} />
                <p className="text-xs text-amber-600 dark:text-amber-400 mt-2">
                  <span className="font-semibold">Важно:</span> Завершите оплату
                  до истечения времени. Средства зачислятся автоматически.
                </p>
              </div>
            )}
          </div>
        </ResponsiveModal.Body>

        <ResponsiveModal.Footer>
          <div className="flex gap-2">
            <Button
              variant="ghost"
              onClick={handleClose}
              className="flex-1 h-10 text-sm"
            >
              Закрыть
            </Button>
            <Button asChild className="flex-1 h-10 text-sm">
              <Link to={ROUTES.DEPOSITS} onClick={handleClose}>
                Мои транзакции
              </Link>
            </Button>
          </div>
        </ResponsiveModal.Footer>
      </ResponsiveModal.Content>
    </ResponsiveModal>
  );
}
